import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  private urlBeforeConnectionLost = '';

  setUrlBeforeConnectionLost(url: string): void {
    if (url !== '/connection-error') {
      this.urlBeforeConnectionLost = url;
    }
  }

  getUrlBeforeConnectionLost(): string {
    return this.urlBeforeConnectionLost;
  }
}
